import { DocumentType, DocumentTemplate } from '../types'
import { ExchangeAgreementTemplate, exchangeAgreementRequiredFields } from './ExchangeAgreementTemplate'
import { W9Template, w9RequiredFields } from './W9Template'
import { IdentificationFormTemplate, identificationFormRequiredFields } from './IdentificationFormTemplate'
import { AssignmentOfPurchaseContractTemplate, assignmentOfPurchaseContractRequiredFields } from './AssignmentOfPurchaseContractTemplate'
import { NoticeOfAssignmentSellerTemplate, noticeOfAssignmentSellerRequiredFields } from './NoticeOfAssignmentSellerTemplate'
import { DisbursementAuthorizationTemplate, disbursementAuthorizationRequiredFields } from './DisbursementAuthorizationTemplate'

export const TEMPLATE_REGISTRY: Record<DocumentType, DocumentTemplate> = {
  'exchange-agreement': {
    id: 'exchange-agreement',
    name: 'Phase 1 Sale Bundle',
    hub: 'sales',
    requiredFields: exchangeAgreementRequiredFields,
    render: (data) => <ExchangeAgreementTemplate data={data} />,
    sourceDocxUrl: '/templates/sales-hub/sale-bundle.docx',
    sourceDocxLabel: 'Phase 1 Sale Bundle (.docx)',
  },
  'w9': {
    id: 'w9',
    name: 'W-9',
    hub: 'sales',
    requiredFields: w9RequiredFields,
    render: (data) => <W9Template data={data} />,
  },
  'identification-form': {
    id: 'identification-form',
    name: '45-Day Identification Notice',
    hub: 'identification',
    requiredFields: identificationFormRequiredFields,
    render: (data) => <IdentificationFormTemplate data={data} />,
    sourceDocxUrl: '/templates/id-hub/identification-notice.docx',
    sourceDocxLabel: '45-Day Identification Notice (.docx)',
  },
  'assignment-of-purchase-contract': {
    id: 'assignment-of-purchase-contract',
    name: 'Replacement Property Assignment',
    hub: 'purchase',
    requiredFields: assignmentOfPurchaseContractRequiredFields,
    render: (data) => <AssignmentOfPurchaseContractTemplate data={data} />,
    sourceDocxUrl: '/templates/purchase-hub/purchase-bundle.docx',
    sourceDocxLabel: 'Phase 2 Purchase Bundle (.docx)',
  },
  'notice-of-assignment-seller': {
    id: 'notice-of-assignment-seller',
    name: 'Notice to Seller',
    hub: 'purchase',
    requiredFields: noticeOfAssignmentSellerRequiredFields,
    render: (data) => <NoticeOfAssignmentSellerTemplate data={data} />,
    sourceDocxUrl: '/templates/purchase-hub/purchase-bundle.docx',
    sourceDocxLabel: 'Phase 2 Purchase Bundle (.docx)',
  },
  'disbursement-authorization': {
    id: 'disbursement-authorization',
    name: 'Disbursement Request',
    hub: 'disbursement',
    requiredFields: disbursementAuthorizationRequiredFields,
    render: (data) => <DisbursementAuthorizationTemplate data={data} />,
    sourceDocxUrl: '/templates/disbursement-hub/disbursement-request.docx',
    sourceDocxLabel: 'Disbursement Request (.docx)',
  },
}
